<template>
	<div></div>
</template>

<script>
export default {
	name: 'GetUndeliveredDispatchesData',
	setup() {},
}
</script>

<style lang="scss" scoped></style>
